import { httpRequest } from "@/utils/HttpRequest";
import { ISearchPage, IPage } from "@/types/ScmTypes";

export interface IVRMSoReportDetail {
    "id": string,
    "customerName": string,    // "客户名称",
    "tradeTypeCode": string,    // "单据类型",
    "tradeTypeName": string,    // "单据类型名称",
    "customerTypeCode": string,    // "客户类型code",
    "customerTypeName": string,    // "客户类型name",
    "shopId": string,    // "站点id",
    "shopName": string,    // "站点名称",
    "code": string,    // "单号",
    "materialCode": string,    // "商品编码",
    "materialName": string,    // "商品名称",
    "orderTypeCode": string,    // "销售类型",
    "orderTypeName": string,    // "销售类型名称",
    "replaceCode": string,    // "替换号",
    "typeCode": string,    // "商品类型编码",
    "typeName": string,    // "商品类型名称",
    "price": string,    // 销售单价,
    "num": string,    // 销售数量,
    "amount": string,    // 销售金额,
    "giftsNum": string,    // 赠品数量,
    "giftsAmount": string,    // 赠品总金额,
    "warehouseName": string,    // "库房",
    "shelfCode": string,    // "货架",
    "costPrice": string,    // 成本价格,
    "costAmount": string,    // 销售成本,
    "profit": string,    // 销售毛利,
    "note": string,    // "备注",
    "settleTime": string,    // 结算日期,
    "createTime": string,    // "2021-06-01 17:string,    //11:string,    //31",
    "updateTime": string,    // "2021-06-01 17:string,    //11:string,    //45",
    "createUser": string,    // "吴杏云",
    "updateUser": string,    // null,
    "payType": string,    // "结算类型code",
    "payTypeName": string,    // "结算类型name",
    "deleteFlag": string,    // 0
}

//搜索条件
export interface IVRMSoReportSearchFields {
    "payType"?: string,    // "结算类型",
    "typeCode"?: string,    // "商品类型",
    "tradeTypeCode"?: string,    // "单据类型",
    "orderTypeCode"?: string,    // "销售类型code",
    "createUser"?: string,    // "业务员",
    "startTime"?: string,    // "开始时间",
    "endTime"?: string,    // "结束时间",
    "customerTypeCode"?: string,    // "客户类型",
    "customerName"?: string,    // "客户名称",
    "materialName"?: string,    // "商品名称",
    "materialCode"?: string,    // "商品编码",
    "code"?: string,    // "销售单编码",
    "shopId"?: string,    // "站点ID"
}

export interface IVRMSoReportSearch
    extends IVRMSoReportSearchFields, ISearchPage {
}
export interface IStatistics {
    saleNum: number, // 4,            // 销售数量
    saleAmount: number, // 826.95,	 // 销售金额
    giftsNum: number, // 0,			 // 赠品数量
    giftsAmount: number, // 0,		 // 赠品金额	
    costAmount: number, // 826.95,    // 销售成本
    profit: number, // 0				 // 销售毛利	
}

//进销存报表
class SoReportService {
    async page(searchVo: IVRMSoReportSearch) {
        const apiUrl = "/zzw-vrm/statistics/saleStatistics";
        return await httpRequest.post<IPage<IVRMSoReportDetail>>(apiUrl, searchVo);
    }
    async export(searchVo: IVRMSoReportSearch) {
        const apiUrl = "/zzw-vrm/statistics/saleStatisticsExport";
        return await httpRequest.postFile<boolean>(apiUrl, searchVo, { timeout: 300000 });
    }
    // 头部统计
    async statistics(searchVo: IVRMSoReportSearch) {
        const apiUrl = "/zzw-vrm/statistics/saleTotal";
        return await httpRequest.post<IStatistics>(apiUrl, searchVo);
    }
}

export const soReportService = new SoReportService();